const MicrophoneIcon = (props: any) => (
    <svg width={25} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M12.499 14.632c1.918 0 3.467-1.41 3.467-3.158V5.158C15.966 3.41 14.417 2 12.499 2 10.58 2 9.032 3.41 9.032 5.158v6.316c0 1.747 1.548 3.158 3.467 3.158Zm6.83-3.158c-.566 0-1.04.379-1.132.894-.474 2.474-2.843 4.369-5.698 4.369-2.855 0-5.224-1.895-5.698-4.369-.093-.515-.566-.894-1.133-.894-.705 0-1.26.568-1.155 1.2.566 3.158 3.34 5.631 6.83 6.084v2.19c0 .578.52 1.052 1.156 1.052.635 0 1.155-.474 1.155-1.053v-2.19c3.49-.452 6.265-2.925 6.831-6.083.116-.632-.45-1.2-1.156-1.2Z"
            fill="#fff"
        />
    </svg>
)

export default MicrophoneIcon
